import { SyntheticEvent } from 'react';

export function isEvent(maybeEvent: unknown): maybeEvent is SyntheticEvent {
  return (maybeEvent as SyntheticEvent)?.nativeEvent instanceof Event;
}
